/* eslint-disable @next/next/no-html-link-for-pages */
import Custom404 from "../../404"
import { PartnerPageEcom } from "../../../components/PartnerPageEcom"
import { PartnerPageFreelancer } from "../../../components/PartnerPageFreelancer"
import { PartnerPageSMB } from "../../../components/PartnerPageSMB"
import { PartnerPageStartup } from "../../../components/PartnerPageStartup"
import { IPartnerWebpage } from "../../../lib/models"
import { getPartnerWebpage } from "../../../service"
import type { GetServerSidePropsContext } from "next"
import React from "react"

interface Props {
  companyType: string
  businessClassificationId?: string
  partnerWebpage: IPartnerWebpage
  errors?: string
}
const PartnerWebpageCompanyType = ({
  companyType,
  businessClassificationId,
  partnerWebpage,
  errors,
}: Props) => {
  const displayEcommercePage =
    companyType === "ecommerce" && partnerWebpage.ecommerce
  const displayFreelancerPage =
    companyType === "freelancer" && partnerWebpage.freelancer
  const displaySMBPage = companyType === "smb" && partnerWebpage.smb
  const displayStartupPage = companyType === "startup" && partnerWebpage.startup

  if (
    errors ||
    !partnerWebpage ||
    !partnerWebpage.active ||
    !partnerWebpage.partnerLogoUrl ||
    !partnerWebpage.cobrandedImageUrl ||
    !partnerWebpage.partnerName ||
    !partnerWebpage.license?.id
  )
    return <Custom404 />

  return displayEcommercePage ? (
    <PartnerPageEcom
      partner={partnerWebpage.partnerName}
      partnerLogoUrl={partnerWebpage.partnerLogoUrl}
      partnerLogoClassName="max-h-7 ml-4"
      percentage={partnerWebpage.percentageSavings}
      license={partnerWebpage.license.id}
      cobrandedImageUrl={partnerWebpage.cobrandedImageUrl}
    />
  ) : displayFreelancerPage ? (
    <PartnerPageFreelancer
      partner={partnerWebpage.partnerName}
      partnerLogoUrl={partnerWebpage.partnerLogoUrl}
      partnerLogoClassName="max-h-7 ml-4"
      percentage={partnerWebpage.percentageSavings}
      license={partnerWebpage.license.id}
      businessClassificationId={businessClassificationId}
      cobrandedImageUrl={partnerWebpage.cobrandedImageUrl}
    />
  ) : displaySMBPage ? (
    <PartnerPageSMB
      partner={partnerWebpage.partnerName}
      partnerLogoUrl={partnerWebpage.partnerLogoUrl}
      partnerLogoClassName="max-h-7 ml-4"
      percentage={partnerWebpage.percentageSavings}
      license={partnerWebpage.license.id}
      businessClassificationId={businessClassificationId}
      cobrandedImageUrl={partnerWebpage.cobrandedImageUrl}
      prefillCompanyType={partnerWebpage.prefillCompanyType}
    />
  ) : displayStartupPage ? (
    <PartnerPageStartup
      partner={partnerWebpage.partnerName}
      partnerLogoUrl={partnerWebpage.partnerLogoUrl}
      partnerLogoClassName="max-h-7 ml-4"
      percentage={partnerWebpage.percentageSavings}
      license={partnerWebpage.license.id}
      businessClassificationId={businessClassificationId}
      cobrandedImageUrl={partnerWebpage.cobrandedImageUrl}
    />
  ) : (
    <Custom404 />
  )
}

export default PartnerWebpageCompanyType

export const getServerSideProps = async (ctx: GetServerSidePropsContext) => {
  const { slug, companyType, businessClassificationId } = ctx.query
  console.log(ctx.query)

  const partnerSlug = slug ? decodeURIComponent(slug as string) : null

  if (partnerSlug) {
    try {
      const partnerWebpage = await getPartnerWebpage(partnerSlug)
      console.log("-->", partnerWebpage)
      return {
        props: {
          partnerWebpage,
          companyType: companyType
            ? decodeURIComponent(companyType as string)
            : null,
          businessClassificationId: businessClassificationId
            ? decodeURIComponent(businessClassificationId as string)
            : null,
        },
      }
    } catch (error) {
      return {
        props: {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          errors: error.message,
        },
      }
    }
  } else {
    return {
      props: {
        errors: "No slug found",
      },
    }
  }
}
